<div class="widget wide-{{widget.size[0]}} tall-{{widget.size[1]}}" [ngClass]="{'no-padding': noPadding}">
  <div class="header"><ng-content select="[widget-header]"></ng-content></div>
  <div class="content"><ng-content select="[widget-content]"></ng-content></div>
</div>
